import { BASE_SERVICE_URL } from '../../../lib/constants'


const remove = async (uid: string): Promise<void> => {
    try {
        return await fetch(BASE_SERVICE_URL + `/s3/${uid}`, {
            credentials: 'same-origin',
            method: 'DELETE'
        }).then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                var error = new Error(response.statusText);
                error.response = response;
                throw error;
            }
        })

    } catch (error) {

    }
}



export default remove